import { AfterContentInit, Component, ElementRef, HostListener, Inject, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { VideoComponentBase } from '../../../../../models/video-component.base.interface';
import { VideoEventType } from '../../../../../models/video-event-type.enum';
import { BunnyTimeData } from '../../models/bunny-time-data.model';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { VideoPlayerBaseComponent } from '../../../base/video-player-base.component';
import { DwConfigService, DwConfigServiceToken, DwLoggingService, DwSecurityUserService } from '@devwareapps/devware-cap';
import { VideoMessagingService } from '../../../../../services/video-messaging.service';
import { Observable, Subscription } from 'rxjs';
import { DwPubSubService } from '../../../../../../z-devware/pubsub/dw-pub-sub-service';
import { DwClientSessionUtilService } from '../../../../../../z-devware/pubsub/dw-client-session-util.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-video-player-bunny',
  template: `
  
   <div class="video-player-shell">
     <div [ngStyle]="videoPlayerStyle" class="video-player-container" *ngIf="videoUrl">
       <iframe id="iframe" #player [src]="videoUrlSafe" (load)="onIframeLoad()" class="video-player-iframe" style="top:0;height:100%;width:100%;" allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;" allowfullscreen="true"></iframe>
       <div class="video-playback-adjustment-badge" *ngIf="seekPreventionNoticeVisible" role="status" aria-live="polite">
         <i class="fa fa-exclamation-circle" [title]="seekPreventionNoticeTooltip" aria-hidden="true"></i>
         <span>{{seekPreventionNoticeText}}</span>
       </div>
     </div>
   </div>

   <div class="video-shell" *ngIf="false">
    <div class="video-frame">
      <iframe
        id="iframe"
        #player
        [attr.src]="videoUrl"
        src2="videoUrlSafe"
        (load)="onIframeLoad()"
        class="video-iframe"
        allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
        allowfullscreen="true">
      </iframe>
    </div>
  </div>
  
  <div *ngIf="false">
    <button class="btn btn-warning" (click)="pauseVideo()">Pause Video</button>
    <button class="btn btn-warning" (click)="playVideo()">Play Video</button>
    <span [hidden]="!initComplete" title="Player JS Init complete"><i class="fa fa-check-circle dw-green fa-2x" ></i> Init Complete ({{initTimeSeconds}}s)</span>
    <span [hidden]="initComplete || recovering"><i class="fa fa-circle-notch fa-spin fa-2x dw-orange" title="Player JS Initializing"></i> Initializing...</span>
    <span [hidden]="initComplete || !recovering"><i class="fa fa-draw-circle fa-spin fa-2x dw-red" title="Player JS Initializing"></i> Recovering...</span>
  </div>
  <!-- 
    Video Url: {{videoUrl}}
    {{videoPlayerStyle | json }}
    {{width}} X {{height}} -->


  `
})
export class VideoPlayerBunnyComponent extends VideoPlayerBaseComponent implements VideoComponentBase, AfterContentInit, OnDestroy, OnChanges {
  videoUrl: string;
  videoUrlSafe: SafeUrl;
  private static videoBroadcastChannel: BroadcastChannel = null;
  private static seekDiagnosticMemoryLogCounts: any = {
    userKey: null,
    totalLogCount: 0,
    videoLogCounts: {}
  };

  @ViewChild('player') playerIframeRef: ElementRef<HTMLIFrameElement>;
  playerIframe: HTMLIFrameElement;

  message: string;
  player: any;
  userSeeked: boolean = false;
  lastTimeData: BunnyTimeData;
  ignoreNextStopEvent: boolean;
  seekFurthestTime: boolean;
  videoStartComplete: boolean;
  videoDuration: number;
  mobileWidth = 850;

  playerStats: {
    videoName: string;
    playerSetupCount: number;
    timeOnPage: number;
    initComplete: boolean,
    started: number,
    paused: number,
    manualPaused: number,
    manualStarted: number,
    timeUpdate: number,
    fallbackProgress: number,
    completed: number,
    initTime?: number
  } = {
      videoName: 'Not Set Yet',
      initComplete: false,
      playerSetupCount: 0,
      started: 0,
      paused: 0,
      manualPaused: 0,
      manualStarted: 0,
      timeUpdate: 0,
      fallbackProgress: 0,
      completed: 0,
      initTime: null,
      timeOnPage: null
    }

  logStats: boolean = true;


  videoPlayerStyle: any = {
    width: '100%',
    'min-width': '350px',
    'min-height': '196px',
    'max-width': '1200px'
  }

  aspectRatio: number = 16 / 9;

  width: number;
  height: number;
  maxHeight: number;
  finalHeight: number;
  finalWidth: string;
  previousWidth: number;
  videoUrl2: string;

  showPlayer = true;
  visibilityState: string;
  seekPreventionNoticeVisible = false;
  seekPreventionNoticeText = 'Playback adjusted';
  seekPreventionNoticeTooltip = 'Seeking ahead is not allowed for this lesson.';

  startTime: any;
  pollIterval: any;
  private seekPreventionNoticeTimeout: any;
  private initRetryTimeout: any;
  private initDiagnosticTimeout: any;
  private initDiagnosticReason: string;
  private durationLoadInProgress = false;
  private durationRequestTimeout: any;
  private durationRequestToken = 0;
  private initWarningLogged = false;
  private iframeLoadCount = 0;
  private playerReadyEventCount = 0;
  private initReadyRetryCount = 0;
  private durationRetryCount = 0;
  private initCompletedEmitted = false;
  private playerErrorCount = 0;
  private playerErrorLogged = false;
  private messageHandler: (ev: MessageEvent) => void;
  private progressFallbackInterval: any;
  private lastNativeProgressMs: number;
  private lastFallbackProgressTime: number;
  private lastAcceptedProgressMs: number;
  private lastAcceptedVideoTimeSeconds: number;
  private playbackRateEstimate = 1;
  private verboseVideoLoggingEnabled = false;
  private verboseVideoLoggingReason: string;
  private lastVerboseProgressLogMs: number;
  private verboseAutoEnabledLogged = false;
  private readonly initDiagnosticDelayMs = 15000;
  private readonly initRetryDelayMs = 250;
  private readonly maxInitRetryMs = 20000;
  private readonly maxInitRecoveryCount = 2;
  private readonly maxDurationRetryCount = 40;
  private readonly durationRequestTimeoutMs = 1000;
  private readonly progressFallbackIntervalMs = 5000;
  private readonly progressFallbackQuietMs = 10000;
  private readonly minPlaybackRateSeekAllowance = 1;
  private readonly maxPlaybackRateSeekAllowance = 1.5;
  private readonly maxProgressSeekAllowanceSeconds = 20;
  private readonly playbackRateEstimateSmoothing = 0.35;
  private readonly minPlaybackRateSampleSeconds = 0.5;
  private readonly maxPlaybackRateSampleSeconds = 30;
  private readonly maxPassiveSeekAcceptSeconds = 20;
  private readonly resumeSeekBackwardsGraceSeconds = 0.5;
  private readonly seekPreventionNoticeDurationMs = 9000;
  private readonly maxSeekDiagnosticLogsPerVideo = 2;
  private readonly maxSeekDiagnosticLogsPerSession = 10;
  private readonly verboseProgressLogIntervalMs = 15000;
  private readonly verboseLoggingStorageKey = 'aviator.video.verboseLogging';
  private readonly verboseAutoLoggingSessionKey = 'aviator.video.verboseLogging.auto';
  private readonly seekDiagnosticCountsSessionKey = 'aviator.video.seekDiagnosticCounts';
  private readonly verboseAutoLoggingTtlMs = 60 * 60 * 1000;

  private dupEventList: {
    [eventName: string]: {
      lastEmitMs: number;
      lastValue?: any;
    };
  } = {};
  iFrameLoaded: boolean;
  initTimeSeconds: number;
  recovering: boolean = false;

  constructor(dwSecurityUserService: DwSecurityUserService, videoMessagingService: VideoMessagingService, dwPubSubService: DwPubSubService,
    @Inject(DwConfigServiceToken) private dwConfigService: DwConfigService, private sanitizer: DomSanitizer, private hostElementRef: ElementRef, private dwLoggingService: DwLoggingService) {
    super(dwSecurityUserService, videoMessagingService, dwPubSubService);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.addMessageTap();
    this.setVideoPlayerStyle();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.video || changes.videoStreamingProvider || changes.allowSeekOverride) {
      this.setupVideoSeek();
    }

    if (!changes.video || changes.video.firstChange) {
      return;
    }

    this.lastInitSrc = null;
    this.teardownPlayer();
    this.iFrameLoaded = false;
    this.initComplete = false;
    this.message = null;
    this.setupVideo();
  }
  private msgTapAdded = false;

  private messageCount = 0;

  private addMessageTap() {
    if (this.msgTapAdded) return;
    this.msgTapAdded = true;

    this.messageHandler = (ev: MessageEvent) => {
      // limit noise: only log mediadelivery origins
      const o = (ev.origin || '').toLowerCase();
      if (!o.includes('mediadelivery.net')) return;

      this.messageCount++;

      if ((this.messageCount - 1) % 60 !== 0) return;

      this.dwPubSubService.emitDebug('Info', 'PJS - window.message', {
        origin: ev.origin,
        dataType: typeof ev.data,
        data: safeTrim(ev.data),
        messageCount: this.messageCount
      });
    };

    window.addEventListener('message', this.messageHandler, true);
  }

  ngOnDestroy(): void {
    this.teardownPlayer();
    this.removeMessageTap();
    this.clearInitTimers();
    this.clearSeekPreventionNotice();
    this.initDiagnosticReason = null;

    const endTime = performance.now();

    const totalTime = endTime - this.startTime;

    this.playerStats.timeOnPage = totalTime;

    if (this.logStats) {
      this.logStats = false;

      if (!this.playerStats.initComplete && totalTime > 3000) {
        this.logPlayerInitWarning('destroy-before-init-complete', false);
      }
    }

    if (this.pollIterval) {
      clearInterval(this.pollIterval);
      this.pollIterval = null;
    }

    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
    this.subscriptions = [];
  }

  lastPaused: boolean | null = null;
  setupVideoStateChecks() {
    if (!this.player) {
      return;
    }

    // Only setup once
    if (this.pollIterval) {
      return;
    }

    this.pollIterval = setInterval(async () => {
      if (document.visibilityState !== 'visible') return;

      this.player.getPaused((value) => this.manualPauseSet(value)); // or player.api('paused') etc.

    }, 750);
  }

  private manualPauseSet(paused: boolean) {

    if (this.lastPaused === null) { this.lastPaused = paused; return; }

    if (this.lastPaused !== paused) {
      this.lastPaused = paused;

      if (this.lastPaused) {
        this.onPause(true);

        // this.playerStats.manualPaused++;
        // console.log('Manual pause', { ...this.playerStats });
        // this.dwPubSubService.emitDebug('Info', 'PJS - Manual pause', { ...this.playerStats });

        if (this.playerStats.paused == 0) {

        }
      } else {
        this.onPlay(true);

        // this.playerStats.manualStarted++;
        // console.log('Manual play', { ...this.playerStats });
        // this.dwPubSubService.emitDebug('Info', 'PJS - Manual play', { ...this.playerStats });
      }
    }
  }

  setupVideo(): void {
    this.startTime = performance.now();
    this.clearInitTimers();
    this.clearSeekPreventionNotice();
    this.setupVerboseVideoLogging();
    this.initWarningLogged = false;
    this.playerErrorLogged = false;
    this.playerErrorCount = 0;
    this.verboseAutoEnabledLogged = false;
    this.lastNativeProgressMs = null;
    this.lastFallbackProgressTime = null;
    this.lastAcceptedProgressMs = performance.now();
    this.lastAcceptedVideoTimeSeconds = null;
    this.playbackRateEstimate = 1;
    this.lastVerboseProgressLogMs = null;
    this.iframeLoadCount = 0;
    this.playerReadyEventCount = 0;
    this.initReadyRetryCount = 0;
    this.durationRetryCount = 0;
    this.durationLoadInProgress = false;
    this.durationRequestToken++;
    this.initAttempt = 0;
    this.initCompletedEmitted = false;
    this.videoStartComplete = false;
    this.recovering = false;

    super.setupVideo();

    const videoKey = this.video?.VideoKey;
    const videoLibraryKey = this.videoLibrary?.VideoLibraryKey;

    this.playerStats.videoName = this.video?.VideoName || 'Unknown';

    if (!videoKey) {
      return;
    }

    // this didn't look like it will change so didn't make it a configurable option
    const responsive = true;


    const cacheBust = `${Date.now()}-${DwClientSessionUtilService.generateUuid()}`;
    const modulePlaybackSource = this.playback?.OnlineSource;
    // The web client preserves Bunny's iframe and Player.js integration.
    // CDN-authenticated HLS sources are selected only for capable mobile clients.
    const playerUrl = modulePlaybackSource?.Format === 'bunny-embed'
      ? modulePlaybackSource.Url
      : this.video?.DirectPlayUrl;
    const embedUrl = playerUrl?.replace('/play', '/embed');
    const separator = embedUrl?.includes('?') ? '&' : '?';
    this.videoUrl = embedUrl
      ? `${embedUrl}${separator}autoplay=${this.videoStreamingProvider.AutoPlay}&cacheBust=${encodeURIComponent(cacheBust)}`
      : null;
    
    this.videoUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoUrl);

    this.logPlayerDiagnostic('Info', 'PJS - Setup video', {
      cacheBust,
      hasPlayerJs: !!(window as any).playerjs
    });
    this.logVerboseVideoDiagnostic('setup-video', { cacheBust, hasPlayerJs: !!(window as any).playerjs });
    this.scheduleInitDiagnostic('iframe-load-pending');
  }

  @HostListener('window:resize', ['$event'])
  public resize(event: any): void {
    // re-configure the grid style upon browser resize
    this.setVideoPlayerStyle();
  }

  ngAfterContentInit(): void {
    // this.setupIframe();
    // console.log('After content init');

    // this.setupPlayer();


  }

  async onIframeLoad() {
   // console.log('I-frame loaded event');
    this.setupIframe();

    const src = this.playerIframe.getAttribute('src') || '';
    const srcProp = this.playerIframe.src || '';
    this.iframeLoadCount++;

    this.logPlayerDiagnostic('Info', 'PJS - Iframe load', { src, srcProp });
    this.logVerboseVideoDiagnostic('iframe-load', { src, srcProp });

    // Ignore placeholder loads
    if (!srcProp || srcProp === 'about:blank') return;

    // Only init once per src
    if (this.lastInitSrc === src && this.player) return;
    this.lastInitSrc = src;

    // await this.delay(150);
 
    this.teardownPlayer();
    this.setupPlayer();

   // await this.verifyPlayer(src);
  }

  private async verifyPlayer(src: string) {

    this.dwPubSubService.emitDebug('Info', 'PJS - Verify start', { srcProp: src, vis: document.visibilityState });

    const ok = await this.verifyWithBackoff(src);

    if (ok) {
      this.initVideoPlayer();
      this.dwPubSubService.emitDebug('Warn', 'PJS - Verify complete', { ...this.playerStats });
      return;
    }

    // Only now do a single reload attempt (not every 2 seconds)
    if (this.initAttempt < 2) {
      this.initAttempt++;
      this.dwPubSubService.emitDebug('Warn', 'PJS - Recover reload iframe', { attempt: this.initAttempt });
      this.recoverPlayer('Verify failed');
    } else {
      this.dwPubSubService.emitDebug('Error', 'PJS - Init failed after retries', {
        src,
        attempts: this.initAttempt
      });
    }
  }

  private setupIframe() {
    const viewChildIframe = this.playerIframeRef?.nativeElement;
    if (viewChildIframe) {
      this.playerIframe = viewChildIframe;
      return;
    }

    this.playerIframe = this.hostElementRef?.nativeElement?.querySelector('iframe.video-player-iframe');
  }

  setupPlayer() {
    if (this.player) {
      return;
    }

    if (!this.playerIframe) {

      this.logPlayerInitWarning('iframe-not-found');
      return;
    }

    if (!this.videoUrl) {
      this.logPlayerInitWarning('video-url-not-set');
      return;
    }

    this.setVideoPlayerStyle();

    // set src attribute so player js can find it (it doesn't work with Angular bound src attribute)
    //this.playerIframe.src = this.videoUrl;

    if (!this.playerIframe.src) {
      this.logPlayerInitWarning('iframe-src-not-set');
      return;
    }

    const playerJs = (window as any).playerjs;

    if (!playerJs) {
      this.message = 'Could not find Bunny.Net playerjs for Video Events';
      console.warn(this.message);
      this.logPlayerInitWarning('playerjs-not-found');
      return;
    }

    try {
      this.player = new playerJs.Player(this.playerIframe);
    } catch (error) {
      this.logPlayerDiagnostic('Warn', 'PJS - error creating', { error });
      this.dwLoggingService.logError('Bunny.net player - Error creating Playerjs instance', error);
      return;
    }

    if (!this.player) {
      this.logPlayerInitWarning('playerjs-created-null-player');
      return;
    }

    this.message = 'Player setup';

    this.playerStats.playerSetupCount += 1;

    this.logPlayerDiagnostic('Info', 'PJS - Player setup');
    this.logVerboseVideoDiagnostic('player-setup');
    this.scheduleInitDiagnostic('player-setup');
    
    this.setupPlayerJsEvents();
  }

  private teardownPlayer() {
    this.clearInitTimers();
    this.clearProgressFallbackPolling();
    try { this.player?.off?.('play'); } catch { }
    try { this.player?.off?.('pause'); } catch { }
    try { this.player?.off?.('ended'); } catch { }
    try { this.player?.off?.('timeupdate'); } catch { }
    try { this.player?.off?.('ready'); } catch { }
    try { this.player?.off?.('error'); } catch { }
    try { this.player = null; } catch { }
  }

  private setupPlayerJsEvents() {
    const player = this.player;

    if (!player) {
      return;
    }

    this.initVideoPlayer();

    if (!this.player || this.player !== player) {
      this.logVerboseVideoDiagnostic('setup-events-aborted-stale-player');
      return;
    }

    player.on('play', (data) => {

      this.dedupeAndInvoke('play', () => this.onPlay(false));

    });

    player.on('pause', (data) => {
      this.dedupeAndInvoke('pause', () => this.onPause(false));
    });

    player.on('error', (error) => this.onPlayerJsError(error));

    player.on('ended', (data) => {
      this.playerStats.completed++;

      if (this.ignoreNextStopEvent) {
        this.ignoreNextStopEvent = false;
        return;
      }

      this.onVideoEvent(VideoEventType.videoCompleted, { ...this.playerStats });
    });

    player.on('timeupdate', (timeData: BunnyTimeData) => this.handlePlayerProgress(timeData?.seconds, false));

    player.on("ready", this.onReady.bind(this));
  }

  private async recoverPlayer(reason: string) {
    this.dwPubSubService.emitDebug('Warn', 'PJS - Recover start', { reason });

    this.recovering = true;
    this.clearInitTimers();
    this.startTime = performance.now();
    this.initComplete = false;
    this.playerStats.initComplete = false;
    this.initReadyRetryCount = 0;
    this.durationRetryCount = 0;
    this.lastInitSrc = null;
    this.videoStartComplete = false;

    this.teardownPlayer();

    // Force a hard reload of the iframe
    const old = this.videoUrl!;
    const newUrl = this.bumpCacheBust(old);

    this.dwPubSubService.emitDebug('Warn', 'PJS - Recover reload iframe', { old, newUrl });
    this.logVerboseVideoDiagnostic('recover-reload-iframe', { reason, old, newUrl });

    // about:blank hop helps on iOS
    this.playerIframe.setAttribute('src', 'about:blank');

    setTimeout(() => {
      this.videoUrl = newUrl;
      this.playerIframe.setAttribute('src', newUrl);
    }, 50);
  }

  private bumpCacheBust(url: string): string {
    const bust = `${Date.now()}-${DwClientSessionUtilService.generateUuid()}`;
    try {
      const u = new URL(url);
      u.searchParams.set('cacheBust', bust);
      return u.toString();
    } catch {
      const join = url.includes('?') ? '&' : '?';
      return `${url}${join}cacheBust=${encodeURIComponent(bust)}`;
    }
  }

  private onPlay(manual: boolean) {
    if (manual) {
      this.playerStats.manualStarted++;

      if (this.playerStats.started > 0) {
        return;
      }

      //console.log('Manual play', { ...this.playerStats });
    } else {
      this.playerStats.started++;

      //console.log('PJS play', { ...this.playerStats });
    }

    this.onVideoEvent(VideoEventType.videoStarted, this.playerStats);
    this.logVerboseVideoDiagnostic(manual ? 'manual-play' : 'play', { stats: { ...this.playerStats } });

    this.notifyVideoStarted();
  }

  private initAttempt = 0;
  private verifyAttempt = 0;
  private lastInitSrc: string | null = null;
  private verifying = false;

  private async verifyWithBackoff(src: string): Promise<boolean> {
    if (this.verifying) return false;
    this.verifying = true;

    const waits = [300, 800, 1500, 3000, 6000, 10000]; // total ~22s worst case
    try {
      for (let i = 0; i < waits.length; i++) {
        // If iframe src changed while waiting, abort this verify run
        if (!this.playerIframe || this.playerIframe.src !== src) {
          this.dwPubSubService.emitDebug('Warn', 'PJS - Verify aborted, src changed', {
            expected: src,
            actual: this.playerIframe?.src
          });
          return false;
        }

        this.dwPubSubService.emitDebug('Info', 'PJS - Verify wait', { i, waitMs: waits[i] });
        await this.delay(waits[i]);

        const r = await this.verifyPlayerResponsive(2500); // per-ping timeout
        this.dwPubSubService.emitDebug(r.ok ? 'Info' : 'Warn', 'PJS - Verify result', r);

        if (r.ok) return true;
      }

      return false;
    } finally {
      this.verifying = false;
    }
  }

  private delay(ms: number) {
    return new Promise<void>(res => setTimeout(res, ms));
  }

  private verifyPlayerResponsive(timeoutMs = 2000): Promise<{ ok: boolean; duration?: any; reason?: string }> {
    return new Promise((resolve) => {
      const player = this.player;

      if (!player) {
        resolve({ ok: false, reason: 'player-missing' });
        return;
      }

      let finished = false;
      const t = setTimeout(() => {
        if (finished) return;
        finished = true;
        resolve({ ok: false, reason: 'timeout' });
      }, timeoutMs);

      try {
        // duration is a common Player.js getter; replace with whatever getter your wrapper supports
        player.getDuration((d: any) => {
          if (finished) return;
          clearTimeout(t);
          finished = true;
          resolve({ ok: true, duration: d });
        });
      } catch (e) {
        clearTimeout(t);
        resolve({ ok: false, reason: 'exception' });
      }
    });
  }

  private onPause(manual: boolean) {
    if (manual) {
      this.playerStats.manualPaused++;

      if (this.playerStats.paused > 0) {
        return;
      }

      //console.log('Manual pause', { ...this.playerStats });
    } else {
      this.playerStats.paused++;

     // console.log('PJS pause', { ...this.playerStats });
    }

    if (this.ignoreNextStopEvent) {
      this.ignoreNextStopEvent = false;
      return;
    }

    this.onVideoEvent(VideoEventType.videoPaused, this.playerStats);
    this.logVerboseVideoDiagnostic(manual ? 'manual-pause' : 'pause', { stats: { ...this.playerStats } });
  }

  private onReady() {
    this.playerReadyEventCount++;
    this.onVideoEvent(VideoEventType.onReady, this.playerStats);
    this.logVerboseVideoDiagnostic('ready', { stats: { ...this.playerStats } });

    this.initVideoPlayer();
  }

  private onPlayerJsError(error: any) {
    this.playerErrorCount++;

    const diagnostics = {
      ...this.buildPlayerDiagnostics('player-js-error'),
      playerErrorCount: this.playerErrorCount,
      playerError: this.safeDiagnosticValue(error)
    };

    const hasPlaybackEvidence = this.playerStats.timeUpdate > 0 || this.playerStats.started > 0 || this.playerStats.completed > 0;
    const debugKind = this.initComplete || hasPlaybackEvidence ? 'Warn' : 'Error';

    this.dwPubSubService.emitDebug(debugKind, 'PJS - Player js error', diagnostics);
    this.enableVerboseLoggingForSession('player-js-error', diagnostics);
    this.logVerboseVideoDiagnostic('player-js-error', diagnostics);

    if (this.playerErrorLogged || hasPlaybackEvidence) {
      return;
    }

    this.playerErrorLogged = true;
    this.dwLoggingService.logWarning('Bunny.net playerjs error before playback progress', diagnostics, true);
  }

  initComplete = false;

  initVideoPlayer() {

    if (this.initComplete) {

      return;
    }

    //this.setupVideoStateChecks();

    if (!this.player) {
      this.logVerboseVideoDiagnostic('init-aborted-player-missing');
      return;
    }

    if (!this.player.isReady) {
      this.initReadyRetryCount++;
      if (this.initReadyRetryCount === 1 || this.initReadyRetryCount % 20 === 0) {
        this.logPlayerDiagnostic('Warn', 'PJS - Not ready', { initReadyRetryCount: this.initReadyRetryCount });
      }
      this.scheduleInitDiagnostic('player-not-ready');

      const elapsedMs = performance.now() - this.startTime;
      if (elapsedMs < this.maxInitRetryMs) {
        this.initRetryTimeout = setTimeout(() => this.initVideoPlayer(), this.initRetryDelayMs);
      } else {
        this.handlePlayerNotReadyTimeout();
      }

      return;
    }

    const initTime = performance.now() - this.startTime;

    this.playerStats.initTime = Math.round(initTime);

    if (!this.initCompletedEmitted) {
      this.initCompleted.emit(true);
      this.initCompletedEmitted = true;
    }

    this.initTimeSeconds = Math.round(initTime / 100) / 10;

    this.dwPubSubService.emitDebug('Warn', `PJS - Init complete ${this.initTimeSeconds}s`, { ...this.playerStats });

    this.playerStats.initComplete = true;

    const knownDuration = this.getKnownVideoDuration();
    if (knownDuration > 0) {
      this.completeVideoInitialization(knownDuration, false);
      return;
    }

    this.scheduleInitDiagnostic('duration-pending');

    this.loadVideoDuration();
  }

  private loadVideoDuration() {
    if (this.durationLoadInProgress) {
      return;
    }

    this.durationLoadInProgress = true;
    this.tryLoadVideoDuration();
  }

  private tryLoadVideoDuration() {
    if (!this.player) {
      this.durationLoadInProgress = false;
      this.logVerboseVideoDiagnostic('duration-load-aborted-player-missing');
      return;
    }

    const requestToken = ++this.durationRequestToken;
    let requestCompleted = false;

    const finishRequest = (duration: any, source: string) => {
      if (requestCompleted || requestToken !== this.durationRequestToken) {
        return;
      }

      requestCompleted = true;
      this.clearDurationRequestTimeout();

      const parsedDuration = typeof duration === 'number' ? duration : parseFloat(duration);
      if (parsedDuration > 0) {
        this.durationLoadInProgress = false;
        this.completeVideoInitialization(parsedDuration, false);
        return;
      }

      this.retryDurationOrContinue(source, duration);
    };

    this.clearDurationRequestTimeout();
    this.durationRequestTimeout = setTimeout(() => {
      finishRequest(null, 'duration-getter-timeout');
    }, this.durationRequestTimeoutMs);

    try {
      if (!this.player) {
        this.durationLoadInProgress = false;
        this.clearDurationRequestTimeout();
        this.logVerboseVideoDiagnostic('duration-getter-aborted-player-missing');
        return;
      }

      this.player.getDuration((duration) => {
        finishRequest(duration, 'duration-callback');
      });
    } catch (error) {
      this.durationLoadInProgress = false;
      this.clearDurationRequestTimeout();
      this.retryDurationOrContinue('duration-getter-exception', this.safeDiagnosticValue(error));
    }
  }

  private retryDurationOrContinue(reason: string, duration: any) {
    this.durationLoadInProgress = false;
    this.durationRetryCount++;

    const elapsedMs = performance.now() - this.startTime;
    if (this.durationRetryCount > this.maxDurationRetryCount || elapsedMs >= this.maxInitRetryMs) {
      const knownDuration = this.getKnownVideoDuration();
      if (knownDuration > 0) {
        this.logVerboseVideoDiagnostic('duration-player-unavailable-using-known-duration', {
          reason,
          duration,
          elapsedMs,
          durationRetryCount: this.durationRetryCount,
          knownDuration
        });
        this.completeVideoInitialization(knownDuration, false);
        return;
      }

      this.logPlayerInitWarning('duration-unavailable-continue');
      this.logVerboseVideoDiagnostic('duration-unavailable-continue', {
        reason,
        duration,
        elapsedMs,
        durationRetryCount: this.durationRetryCount
      });
      this.completeVideoInitialization(null, true);
      return;
    }

    this.initRetryTimeout = setTimeout(() => this.loadVideoDuration(), this.initRetryDelayMs);
  }

  private completeVideoInitialization(duration: number, durationUnavailable: boolean) {
    if (this.initComplete) {
      return;
    }

    if (duration > 0) {
      this.videoDuration = duration;
    }

    this.initComplete = true;
    this.recovering = false;
    this.durationLoadInProgress = false;
    this.clearInitTimers();

    this.logPlayerDiagnostic(durationUnavailable ? 'Warn' : 'Info', durationUnavailable ? 'PJS - Duration unavailable, continuing' : 'PJS - Duration loaded', {
      duration: this.videoDuration,
      durationUnavailable
    });
    this.logVerboseVideoDiagnostic(durationUnavailable ? 'duration-unavailable-continue' : 'duration-loaded', {
      duration: this.videoDuration,
      durationUnavailable
    });

    this.setupProgressFallbackPolling();
    this.setupVideoStartOptions();

  }

  private getKnownVideoDuration(): number {
    return this.parsePositiveNumber(this.video?.VideoDurationSeconds);
  }

  private parsePositiveNumber(value: any): number {
    const parsedValue = typeof value === 'number' ? value : parseFloat(value);
    return parsedValue > 0 && !isNaN(parsedValue) ? parsedValue : null;
  }

  private scheduleInitDiagnostic(reason: string) {
    if (this.initComplete) {
      return;
    }

    this.initDiagnosticReason = reason;
    if (this.initDiagnosticTimeout) {
      return;
    }

    this.initDiagnosticTimeout = setTimeout(() => {
      this.initDiagnosticTimeout = null;

      if (!this.initComplete) {
        const warningReason = this.initDiagnosticReason || reason;
        this.logPlayerInitWarning(warningReason, this.isTransientInitDiagnostic(warningReason));
      }
    }, this.initDiagnosticDelayMs);
  }

  private handlePlayerNotReadyTimeout() {
    this.enableVerboseLoggingForSession('player-not-ready-timeout', {
      ...this.buildPlayerDiagnostics('player-not-ready-timeout'),
      attempt: this.initAttempt + 1
    });

    if (this.initAttempt < this.maxInitRecoveryCount && this.playerIframe && this.videoUrl) {
      this.initAttempt++;
      this.logPlayerDiagnostic('Warn', 'PJS - Recover after not ready timeout', { attempt: this.initAttempt });
      this.recoverPlayer('player-not-ready-timeout');
      return;
    }

    this.logPlayerInitWarning('player-not-ready-timeout');
  }

  private isTransientInitDiagnostic(reason: string): boolean {
    return reason === 'player-not-ready' || reason === 'duration-pending';
  }

  private clearInitTimers() {
    if (this.initRetryTimeout) {
      clearTimeout(this.initRetryTimeout);
      this.initRetryTimeout = null;
    }

    this.clearDurationRequestTimeout();

    if (this.initDiagnosticTimeout) {
      clearTimeout(this.initDiagnosticTimeout);
      this.initDiagnosticTimeout = null;
    }
    this.initDiagnosticReason = null;
  }

  private clearDurationRequestTimeout() {
    if (!this.durationRequestTimeout) {
      return;
    }

    clearTimeout(this.durationRequestTimeout);
    this.durationRequestTimeout = null;
  }

  private setupProgressFallbackPolling() {
    if (this.progressFallbackInterval) {
      return;
    }

    this.progressFallbackInterval = setInterval(() => this.pollProgressFallback(), this.progressFallbackIntervalMs);
  }

  private clearProgressFallbackPolling() {
    if (!this.progressFallbackInterval) {
      return;
    }

    clearInterval(this.progressFallbackInterval);
    this.progressFallbackInterval = null;
  }

  private pollProgressFallback() {
    const player = this.player;

    if (!player || !this.initComplete || document.visibilityState !== 'visible') {
      return;
    }

    if (this.lastNativeProgressMs && Date.now() - this.lastNativeProgressMs < this.progressFallbackQuietMs) {
      return;
    }

    try {
      player.getCurrentTime((currentTime: number) => this.handlePlayerProgress(currentTime, true));
    } catch (error) {
      this.logPlayerDiagnostic('Warn', 'PJS - Progress fallback failed', { error: this.safeDiagnosticValue(error) });
      this.logVerboseVideoDiagnostic('progress-fallback-failed', { error: this.safeDiagnosticValue(error) });
    }
  }

  private handlePlayerProgress(timeSeconds: any, isFallback: boolean) {
    const currentTimeSeconds = typeof timeSeconds === 'number' ? timeSeconds : parseFloat(timeSeconds);

    if (isNaN(currentTimeSeconds)) {
      return;
    }

    if (isFallback) {
      if (this.lastFallbackProgressTime !== null && Math.abs(currentTimeSeconds - this.lastFallbackProgressTime) < 1) {
        return;
      }

      this.lastFallbackProgressTime = currentTimeSeconds;
      this.playerStats.fallbackProgress++;
    } else {
      this.lastNativeProgressMs = Date.now();
    }

    this.playerStats.timeUpdate++;
    const progressObservedMs = performance.now();
    const playbackAllowanceSeconds = this.getPlaybackSeekAllowanceSeconds(progressObservedMs);
    const timeUpdateResult = this.updateCurrentTime(currentTimeSeconds, playbackAllowanceSeconds);

    if (timeUpdateResult.userSeeked) {
      const seekCorrectionDiagnostics = {
        currentTimeSeconds,
        returnToPosition: timeUpdateResult.returnToPosition,
        attemptedAdvanceSeconds: currentTimeSeconds - timeUpdateResult.returnToPosition,
        playbackAllowanceSeconds,
        isFallbackProgress: isFallback
      };
      const seekDiagnosticLogStatus = this.tryReserveSeekDiagnosticLog();

      this.enableVerboseLoggingForSession('seek-correction', seekCorrectionDiagnostics, false);

      if (this.shouldAcceptPotentialSeekWithoutCorrection(seekCorrectionDiagnostics.attemptedAdvanceSeconds)) {
        this.acceptPotentialSeekWithoutCorrection(currentTimeSeconds, seekCorrectionDiagnostics, seekDiagnosticLogStatus);
        this.updatePlaybackRateEstimate(currentTimeSeconds, progressObservedMs);
        this.lastAcceptedProgressMs = progressObservedMs;
        this.lastAcceptedVideoTimeSeconds = currentTimeSeconds;
      } else {
        this.showSeekPreventionNotice();
        this.logSeekCorrectionWarning({
          ...seekCorrectionDiagnostics,
          seekPreventionNoticeShown: true
        }, seekDiagnosticLogStatus);

        if (!this.player) {
          this.logVerboseVideoDiagnostic('seek-correction-aborted-player-missing', seekCorrectionDiagnostics);
          return;
        }

        this.player.setCurrentTime(timeUpdateResult.returnToPosition);
      }
    } else {
      this.updatePlaybackRateEstimate(currentTimeSeconds, progressObservedMs);
      this.lastAcceptedProgressMs = progressObservedMs;
      this.lastAcceptedVideoTimeSeconds = currentTimeSeconds;
    }

    this.onVideoEvent(VideoEventType.videoProgress, {
      ...this.playerStats,
      isFallbackProgress: isFallback,
      currentTimeSeconds
    });
    this.logVerboseProgressDiagnostic(currentTimeSeconds, isFallback);
  }

  private removeMessageTap() {
    if (!this.messageHandler) {
      return;
    }

    window.removeEventListener('message', this.messageHandler, true);
    this.messageHandler = null;
    this.msgTapAdded = false;
  }

  private logPlayerInitWarning(reason: string, suppressServerLog: boolean = false) {
    const diagnostics = this.buildPlayerDiagnostics(reason);

    this.dwPubSubService.emitDebug('Warn', 'PJS - Init diagnostics', diagnostics);

    if (this.initWarningLogged || suppressServerLog) {
      return;
    }

    this.initWarningLogged = true;
    this.enableVerboseLoggingForSession(`init-warning-${reason}`, diagnostics);
    this.dwLoggingService.logWarning(`Bunny.net playerjs init issue - ${reason}`, diagnostics, true);
  }

  private logPlayerDiagnostic(kind: 'Info' | 'Warn' | 'Error', label: string, data?: any) {
    this.dwPubSubService.emitDebug(kind, label, {
      ...this.buildPlayerDiagnostics(label),
      ...(data || {})
    });
  }

  private logVerboseVideoDiagnostic(label: string, data?: any) {
    if (!this.verboseVideoLoggingEnabled) {
      return;
    }

    this.dwLoggingService.logVerbose(`Bunny.net player verbose - ${label}`, {
      ...this.buildPlayerDiagnostics(label),
      verboseLoggingReason: this.verboseVideoLoggingReason,
      diagnosticUser: this.getDiagnosticUserInfo(),
      ...(data || {})
    }, true);
  }

  private logSeekCorrectionWarning(diagnostics: any, logStatus: any) {
    if (!logStatus.shouldLog) {
      return;
    }

    this.dwLoggingService.logWarning('Bunny.net player seek correction applied', {
      ...this.buildPlayerDiagnostics('seek-correction'),
      ...(diagnostics || {}),
      seekDiagnosticLogStatus: logStatus
    }, true);
  }

  private getPlaybackSeekAllowanceSeconds(progressObservedMs: number): number {
    if (this.lastAcceptedProgressMs === null) {
      return 0;
    }

    const elapsedSeconds = Math.max((progressObservedMs - this.lastAcceptedProgressMs) / 1000, 0);
    return Math.min(elapsedSeconds * this.playbackRateEstimate, this.maxProgressSeekAllowanceSeconds);
  }

  private updatePlaybackRateEstimate(currentTimeSeconds: number, progressObservedMs: number) {
    if (this.lastAcceptedProgressMs === null || this.lastAcceptedVideoTimeSeconds === null) {
      return;
    }

    const elapsedSeconds = (progressObservedMs - this.lastAcceptedProgressMs) / 1000;
    const videoAdvanceSeconds = currentTimeSeconds - this.lastAcceptedVideoTimeSeconds;

    if (elapsedSeconds < this.minPlaybackRateSampleSeconds || elapsedSeconds > this.maxPlaybackRateSampleSeconds || videoAdvanceSeconds <= 0) {
      return;
    }

    const observedPlaybackRate = videoAdvanceSeconds / elapsedSeconds;
    const clampedPlaybackRate = Math.min(
      Math.max(observedPlaybackRate, this.minPlaybackRateSeekAllowance),
      this.maxPlaybackRateSeekAllowance
    );

    this.playbackRateEstimate = (this.playbackRateEstimate * (1 - this.playbackRateEstimateSmoothing))
      + (clampedPlaybackRate * this.playbackRateEstimateSmoothing);
  }

  private showSeekPreventionNotice() {
    this.seekPreventionNoticeVisible = true;

    if (this.seekPreventionNoticeTimeout) {
      clearTimeout(this.seekPreventionNoticeTimeout);
    }

    this.seekPreventionNoticeTimeout = setTimeout(() => {
      this.seekPreventionNoticeVisible = false;
      this.seekPreventionNoticeTimeout = null;
    }, this.seekPreventionNoticeDurationMs);
  }

  private clearSeekPreventionNotice() {
    this.seekPreventionNoticeVisible = false;

    if (!this.seekPreventionNoticeTimeout) {
      return;
    }

    clearTimeout(this.seekPreventionNoticeTimeout);
    this.seekPreventionNoticeTimeout = null;
  }

  private shouldAcceptPotentialSeekWithoutCorrection(attemptedAdvanceSeconds: number): boolean {
    return attemptedAdvanceSeconds > 0 && attemptedAdvanceSeconds <= this.maxPassiveSeekAcceptSeconds;
  }

  private acceptPotentialSeekWithoutCorrection(currentTimeSeconds: number, diagnostics: any, logStatus: any) {
    this.userSeeked = false;
    this.furthestWatchedTime = currentTimeSeconds;

    if (!logStatus.shouldLog) {
      return;
    }

    this.logVerboseVideoDiagnostic('seek-correction-suppressed', {
      ...diagnostics,
      seekDiagnosticLogStatus: logStatus,
      maxPassiveSeekAcceptSeconds: this.maxPassiveSeekAcceptSeconds
    });
  }

  private logVerboseProgressDiagnostic(currentTimeSeconds: number, isFallback: boolean) {
    if (!this.verboseVideoLoggingEnabled) {
      return;
    }

    if (!this.shouldLogVerboseProgress()) {
      return;
    }

    this.logVerboseVideoDiagnostic('progress', {
      currentTimeSeconds,
      isFallback,
      furthestWatchedTime: this.furthestWatchedTime,
      stats: { ...this.playerStats }
    });
  }

  private shouldLogVerboseProgress(): boolean {
    const now = Date.now();

    if (this.lastVerboseProgressLogMs && now - this.lastVerboseProgressLogMs < this.verboseProgressLogIntervalMs) {
      return false;
    }

    this.lastVerboseProgressLogMs = now;
    return true;
  }

  private buildPlayerDiagnostics(reason: string) {
    const iframeSrc = this.playerIframe?.src;
    const elapsedMs = this.startTime ? Math.round(performance.now() - this.startTime) : null;
    const playerJs = (window as any).playerjs;

    return {
      reason,
      elapsedMs,
      videoId: this.video?.VideoId,
      videoName: this.video?.VideoName,
      videoKey: this.video?.VideoKey,
      providerId: this.videoStreamingProvider?.VideoStreamingProviderId,
      directPlayUrlSet: !!this.video?.DirectPlayUrl,
      iframeLoadCount: this.iframeLoadCount,
      iframeSrcSet: !!iframeSrc,
      iframeSrcHost: this.getUrlHost(iframeSrc),
      playerJsLoaded: !!playerJs,
      playerExists: !!this.player,
      playerIsReady: !!this.player?.isReady,
      playerReadyEventCount: this.playerReadyEventCount,
      initReadyRetryCount: this.initReadyRetryCount,
      durationRetryCount: this.durationRetryCount,
      videoDuration: this.videoDuration,
      playbackRateEstimate: Math.round(this.playbackRateEstimate * 100) / 100,
      messageCount: this.messageCount,
      documentVisibility: document.visibilityState,
      userAgent: navigator.userAgent,
      diagnosticUser: this.getDiagnosticUserInfo(),
      stats: { ...this.playerStats }
    };
  }

  private setupVerboseVideoLogging() {
    const browserSwitch = this.getBrowserVerboseLoggingSwitch();
    const autoSwitch = this.getAutoVerboseLoggingSwitch();
    const configuredUser = this.isConfiguredDiagnosticUser();

    this.verboseVideoLoggingEnabled = browserSwitch || autoSwitch.enabled || configuredUser;
    this.verboseVideoLoggingReason = browserSwitch ? 'browser-switch' : autoSwitch.reason || (configuredUser ? 'configured-user' : null);
  }

  private getBrowserVerboseLoggingSwitch(): boolean {
    try {
      const queryValue = new URLSearchParams(window.location.search).get('videoDiagnostics');
      if (this.isTruthy(queryValue)) {
        return true;
      }

      return this.isTruthy(window.localStorage?.getItem(this.verboseLoggingStorageKey))
        || this.isTruthy(window.sessionStorage?.getItem(this.verboseLoggingStorageKey));
    } catch {
      return false;
    }
  }

  private getAutoVerboseLoggingSwitch(): { enabled: boolean; reason?: string } {
    try {
      const rawValue = window.sessionStorage?.getItem(this.verboseAutoLoggingSessionKey);
      if (!rawValue) {
        return { enabled: false };
      }

      const autoLoggingInfo = JSON.parse(rawValue);
      const enabledAtMs = autoLoggingInfo?.enabledAtMs || 0;

      if (!enabledAtMs || Date.now() - enabledAtMs > this.verboseAutoLoggingTtlMs) {
        window.sessionStorage.removeItem(this.verboseAutoLoggingSessionKey);
        return { enabled: false };
      }

      return { enabled: true, reason: autoLoggingInfo.reason || 'auto-enabled' };
    } catch {
      return { enabled: false };
    }
  }

  private enableVerboseLoggingForSession(reason: string, diagnostics?: any, writeAutoEnabledLog: boolean = true) {
    const wasEnabled = this.verboseVideoLoggingEnabled;

    this.verboseVideoLoggingEnabled = true;
    this.verboseVideoLoggingReason = reason;

    try {
      window.sessionStorage?.setItem(this.verboseAutoLoggingSessionKey, JSON.stringify({
        reason,
        enabledAtMs: Date.now()
      }));
    } catch {
    }

    if (!writeAutoEnabledLog || (wasEnabled && this.verboseAutoEnabledLogged)) {
      return;
    }

    this.verboseAutoEnabledLogged = true;
    this.logVerboseVideoDiagnostic('auto-enabled', {
      triggerReason: reason,
      triggerDiagnostics: diagnostics
    });
  }

  private tryReserveSeekDiagnosticLog() {
    try {
      const rawValue = window.sessionStorage?.getItem(this.seekDiagnosticCountsSessionKey);
      const logCounts = rawValue ? JSON.parse(rawValue) : {};

      return this.reserveSeekDiagnosticLog(logCounts, updatedLogCounts => {
        window.sessionStorage?.setItem(this.seekDiagnosticCountsSessionKey, JSON.stringify(updatedLogCounts));
      });
    } catch {
      return this.reserveSeekDiagnosticLog(VideoPlayerBunnyComponent.seekDiagnosticMemoryLogCounts);
    }
  }

  private reserveSeekDiagnosticLog(logCounts: any, saveLogCounts?: (updatedLogCounts: any) => void) {
    const userKey = this.getSeekDiagnosticUserKey();
    const videoKey = this.getSeekDiagnosticVideoKey();
    const defaultLogStatus = {
      shouldLog: true,
      userKey,
      videoKey,
      videoLogCount: 1,
      sessionLogCount: 1,
      maxVideoLogCount: this.maxSeekDiagnosticLogsPerVideo,
      maxSessionLogCount: this.maxSeekDiagnosticLogsPerSession
    };

    if (logCounts.userKey && logCounts.userKey !== userKey) {
      logCounts.totalLogCount = 0;
      logCounts.videoLogCounts = {};
    }

    logCounts.userKey = userKey;
    logCounts.totalLogCount = logCounts.totalLogCount || 0;
    logCounts.videoLogCounts = logCounts.videoLogCounts || {};

    const currentVideoLogCount = logCounts.videoLogCounts[videoKey] || 0;
    const currentSessionLogCount = logCounts.totalLogCount || 0;
    const shouldLog = currentVideoLogCount < this.maxSeekDiagnosticLogsPerVideo
      && currentSessionLogCount < this.maxSeekDiagnosticLogsPerSession;

    if (!shouldLog) {
      return {
        ...defaultLogStatus,
        shouldLog: false,
        videoLogCount: currentVideoLogCount,
        sessionLogCount: currentSessionLogCount
      };
    }

    const nextVideoLogCount = currentVideoLogCount + 1;
    const nextSessionLogCount = currentSessionLogCount + 1;
    logCounts.videoLogCounts[videoKey] = nextVideoLogCount;
    logCounts.totalLogCount = nextSessionLogCount;

    if (saveLogCounts) {
      saveLogCounts(logCounts);
    }

    return {
      ...defaultLogStatus,
      videoLogCount: nextVideoLogCount,
      sessionLogCount: nextSessionLogCount
    };
  }

  private getSeekDiagnosticUserKey(): string {
    const user = this.getCurrentApplicationUser();
    return this.normalizeDiagnosticValue(user?.UserId || user?.Email || user?.UserName || 'anonymous');
  }

  private getSeekDiagnosticVideoKey(): string {
    return this.normalizeDiagnosticValue(this.video?.VideoId || this.video?.VideoKey || this.videoUrl || 'unknown-video');
  }

  private isConfiguredDiagnosticUser(): boolean {
    const user = this.getCurrentApplicationUser();
    if (!user) {
      return false;
    }

    return this.matchesList((environment as any).videoDiagnosticsUserIds, user.UserId)
      || this.matchesList((environment as any).videoDiagnosticsUserNames, user.UserName)
      || this.matchesList((environment as any).videoDiagnosticsUserEmails, user.Email);
  }

  private matchesList(values: any[], currentValue: any): boolean {
    if (!values?.length || currentValue === null || currentValue === undefined) {
      return false;
    }

    const normalizedCurrentValue = this.normalizeDiagnosticValue(currentValue);
    return values.some(value => this.normalizeDiagnosticValue(value) === normalizedCurrentValue);
  }

  private normalizeDiagnosticValue(value: any): string {
    return (value || '').toString().trim().toLowerCase();
  }

  private isTruthy(value: string): boolean {
    const normalizedValue = this.normalizeDiagnosticValue(value);
    return normalizedValue === '1' || normalizedValue === 'true' || normalizedValue === 'yes' || normalizedValue === 'on';
  }

  private getDiagnosticUserInfo() {
    const user = this.getCurrentApplicationUser();

    return {
      userId: user?.UserId,
      userName: user?.UserName,
      email: this.maskEmail(user?.Email)
    };
  }

  private getCurrentApplicationUser(): any {
    return this.dwSecurityUserService?.securityContext?.ApplicationUser
      || (this.dwSecurityUserService as any)?.securityState?.securityContext?.ApplicationUser;
  }

  private maskEmail(email: string): string {
    if (!email) {
      return null;
    }

    const parts = email.split('@');
    if (parts.length !== 2) {
      return '***';
    }

    const name = parts[0] || '';
    const domain = parts[1] || '';
    const visibleName = name.length <= 2 ? `${name.substring(0, 1)}***` : `${name.substring(0, 2)}***`;

    return `${visibleName}@${domain}`;
  }

  private getUrlHost(url: string): string {
    if (!url) {
      return null;
    }

    try {
      return new URL(url).host;
    } catch {
      return null;
    }
  }

  private safeDiagnosticValue(value: any): any {
    if (!value) {
      return value;
    }

    if (typeof value === 'string') {
      return safeTrim(value);
    }

    if (value instanceof Error) {
      return {
        name: value.name,
        message: value.message,
        stack: safeTrim(value.stack)
      };
    }

    try {
      return JSON.parse(JSON.stringify(value));
    } catch {
      return safeTrim(String(value));
    }
  }

  setupVideoStartOptions() {
    if (this.videoStartComplete) {
      return;
    }

    const player = this.player;

    if (!player) {
      this.logVerboseVideoDiagnostic('start-options-aborted-player-missing');
      return;
    }

    this.videoStartComplete = true;

    if (this.videoStreamingProvider.ContinueFromLastPosition) {
      this.setupResumePosition();
    }

    if (this.videoStreamingProvider.AutoPlay) {
      player.play();
    }

  }

  private setupResumePosition() {
    const resumeTimeSeconds = this.furthestWatchedTime || 0;

    if (resumeTimeSeconds <= 0) {
      return;
    }

    const durationKnown = this.videoDuration > 0;
    if (durationKnown && resumeTimeSeconds >= Math.round(this.videoDuration)) {
      return;
    }

    this.seekFurthestTime = true;
    const player = this.player;

    if (!player) {
      this.logVerboseVideoDiagnostic('resume-position-aborted-player-missing');
      return;
    }

    try {
      player.getCurrentTime((currentTime: any) => {
        this.seekToResumePosition(resumeTimeSeconds, currentTime);
      });
    } catch {
      this.seekToResumePosition(resumeTimeSeconds, this.currentTime || 0);
    }
  }

  private seekToResumePosition(resumeTimeSeconds: number, currentTime: any) {
    const currentTimeSeconds = typeof currentTime === 'number' ? currentTime : parseFloat(currentTime);

    if (!isNaN(currentTimeSeconds) && currentTimeSeconds > resumeTimeSeconds + this.resumeSeekBackwardsGraceSeconds) {
      this.logVerboseVideoDiagnostic('resume-seek-skipped', {
        currentTimeSeconds,
        resumeTimeSeconds,
        reason: 'playback-already-past-resume-time'
      });
      return;
    }

    if (!this.player) {
      this.logVerboseVideoDiagnostic('resume-seek-aborted-player-missing');
      return;
    }

    this.player.setCurrentTime(resumeTimeSeconds);
  }

  pauseVideo() {
    if (!this.player) {
      this.dwPubSubService.emitDebug('Info', `BP - this.player is null`, { ...this.playerStats });
      return;
    }

    this.dwPubSubService.emitDebug('Info', `PJS Pause`, { ...this.playerStats });

    this.player.pause();
  }


  playVideo() {
    if (!this.player) {
      this.dwPubSubService.emitDebug('Info', `BP - this.player is null`, { ...this.playerStats });
      return;
    }

    this.dwPubSubService.emitDebug('Info', `PJS Play`, { ...this.playerStats });

    this.player.play();
  }


  setVideoPlayerStyle() {
    // Calculate the video player style based on the current width of the host element and using the aspect ratio
    if (!this.hostElementRef?.nativeElement) {
      return;
    }
    this.width = this.hostElementRef.nativeElement?.firstChild?.clientWidth;
    const offsetTop: number = Math.round(this.hostElementRef.nativeElement?.getBoundingClientRect()?.top || 0);

    const rootStyle: any = document.querySelector(':root');
    if (offsetTop) {
      rootStyle?.style?.setProperty('--video-player-width', `${offsetTop}px`);
    }

    if (!this.width) {

      setTimeout(() => {
        this.setVideoPlayerStyle();

      }, 50);
      return;
    }

    if (this.previousWidth === this.width) {
      return;
    }

    this.previousWidth = this.width;

    this.height = Math.round(this.width / this.aspectRatio) + 2;

    this.maxHeight = window.innerHeight - offsetTop - 100;

    this.finalHeight = this.height;
    this.finalWidth = '100%';

    if (this.finalHeight > this.maxHeight && this.width > this.mobileWidth) {
      this.finalHeight = this.maxHeight;
      const adjustedWidth = Math.round(this.finalHeight * this.aspectRatio) - 2;

      this.finalWidth = `${adjustedWidth}px`;
    }

    // Height is deliberately NOT set here. The container's CSS owns
    // `aspect-ratio: 16 / 9` (see styles/features/lesson-view.scss), so
    // height is recomputed live from the rendered width by the browser.
    // Historically this was `height: \`${this.finalHeight}px\`` but the
    // upstream calculation bakes the height from an early (~100px)
    // clientWidth read and never recovers — CSS aspect-ratio avoids the
    // stale-width problem entirely.
    this.videoPlayerStyle = {
      'width': this.finalWidth,
      'min-width': '350px',
    };

    this.videoWidthChanged.emit(this.finalWidth);
  }


  private dedupeAndInvoke<T>(
    eventName: string,
    //value: T,
    invoke: () => void,
    options?: {
      windowMs?: number;          // default 300ms
      compare?: (a: T, b: T) => boolean; // custom equality
      logPrefix?: string;         // for debug labeling
    }
  ): void {
    const now = Date.now();
    const windowMs = options?.windowMs ?? 300;
    const compare = options?.compare ?? ((a, b) => a === b);
    const label = options?.logPrefix ?? 'Player.Dedupe';

    const entry = this.dupEventList[eventName];

    // First occurrence → always allow
    if (!entry) {
      this.dupEventList[eventName] = {
        lastEmitMs: now,
        //lastValue: value
      };

      //this.dwPubSubService.emitDebug('Info', `${label}.${eventName}.First`, {  });
      invoke();
      return;
    }

    // Time-window dedupe
    const deltaMs = now - entry.lastEmitMs;
    if (deltaMs < windowMs) {
      this.dwPubSubService.emitDebug(
        'Warn',
        `${label}.${eventName}.Skip`,
        { deltaMs, windowMs }
      );
      return;
    }

    // Accept
    entry.lastEmitMs = now;

    invoke();
  }
}

function safeTrim(data: string, maxLength: number = 512): any {

  if (data?.length > maxLength) {
    return `${data.substring(0, maxLength)}... (truncated)`;
  }

  return data;

}
